import React from 'react'

function Trailer({data}) {
   //-------------function for checking empty array----------
function isEmpty(obj) {
  for (const prop in obj) {
      if (Object.hasOwn(obj, prop)) {
          return false;
      }
  }
  return true; 
}

const trailer = data.vimeoId ? <video  controls 
style={{height:'100%',width:'100%'}} >
  <source src={`https://admin.ebillet.dk/trailers/${data.vimeoId}.mp4`} type="video/mp4" />
</video> 
: null

//  console.log(data)
  return (
    <div className='trailerContainer'>
      <div style={{height:'130px',width:'242px'}}>
      {trailer}
      </div>
      <div style={{marginTop:'20px'}}>
        <p style={{fontSize:'12px',marginBottom:'7px',fontWeight:700}}>Trailer-ID</p>
        <p style={{border:'1px solid #dee0e3',width:'244px',padding:'5px 7px',borderRadius:'4px',height:'40px'}}>{data.vimeoId ? data.vimeoId : ''}</p>
      </div>
      <div style={{marginTop:'20px'}}>
        <p style={{fontSize:'12px',marginBottom:'7px',fontWeight:700}}>Trailer-censur</p>
        <p style={{border:'1px solid #dee0e3',width:'244px',padding:'5px 7px',borderRadius:'4px',margin:0,height:'40px'}}>
          {isEmpty(data.trailerCensoring) === false  ? data.trailerCensoring : data.trailerCensoring > 0 ? data.trailerCensoring :''}</p>
        <p style={{fontSize:'12px'}}>Sættes til A, 7, 11 eller 15</p>
      </div>
      <p style={{margin:0,fontWeight:700,fontSize:'12px'}}>Størrelse</p>
      <p style={{fontWeight:400,marginTop:'-2px',fontSize:'12px'}}>1080 x 1600 px</p>
    </div>
  )
}

export default Trailer